import React, { Component } from 'react'
import {
  Modal,
  Button,
  FormControl,
  ControlLabel,
  FormGroup
} from 'react-bootstrap'
import autobind from 'autobind-decorator'
import _ from 'lodash'
import PropTypes from 'prop-types'

@autobind
export default class EditableFieldDialog extends Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
    show: PropTypes.bool.isRequired,
    edits: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    fields: PropTypes.array.isRequired
  }

  buildFieldContainer(field) {
    let edits = this.props.edits
    let {
      label,
      value,
      type,
      fieldName,
      displayValue,
      editable = true,
      valueRenderer
    } = field
    if (displayValue !== undefined) {
      value = displayValue
    }
    if (edits[fieldName] !== undefined) {
      value = edits[fieldName]
    }
    let valueElement =
      valueRenderer !== undefined ? valueRenderer(field) : value
    if (type === 'checkbox') {
      let onChange = event =>
        this.props.onChange({
          fieldName,
          value: event.target.checked
        })
      valueElement = (
        <input
          type='checkbox'
          data-test-id={'room-clean-checkbox'}
          checked={value}
          disabled={!editable}
          onChange={editable ? onChange : undefined}
        />
      )
    }
    return (
      <FormGroup key={fieldName || label}>
        <ControlLabel className={'col-xs-4'}>{label}</ControlLabel>
        <FormControl.Static className={'col-xs-8'}>
          {valueElement}
        </FormControl.Static>
      </FormGroup>
    )
  }

  render() {
    let { title, fields, show, edits, onClose, onSave } = this.props

    return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className='form-horizontal'>
            {fields.map(field => this.buildFieldContainer(field))}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
          <Button
            bsStyle='success'
            onClick={onSave}
            disabled={_.isEmpty(edits)}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/editableFieldDialog.js